import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';

@Component({
    selector: 'ea-gauge-chart',
    templateUrl: './ea-gauge.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./ea-gauge.component.scss'],
    standalone: false
})
export class EaGaugeComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  @Input() options: any;
  @Input() set gaugeData(val: any) {
    if (val) {
      this._gaugeData = val;
      this.initOptions();
    }
  }
  get gaugeData() {
    return this._gaugeData;
  }
  _gaugeData = {};
  @Input() title: string;

  @Input() height = 'auto';
  @Input() width = 'auto';

  gaugeOptions: any;

  riskLabel: string;
  private riskLabels = [
    "<span style='font-size: 12px; color : #707070;'>Une performance moyenne de 2% pour privilégier une *garantie en capital *</span>",
    "<span style='font-size: 12px; color : #707070;'>Une performance moyenne de 5% en acceptant en risque potentiel de perte en capital de 3%</span>",
    "<span style='font-size: 12px; color : #707070;'>Une performance moyenne de 8% en acceptant en risque potentiel *de *perte en capital de 7%</span>",
    "<span style='font-size: 12px; color : #707070;'>Une performance moyenne de 15% en acceptant en risque potentiel *de *perte en capital de 12%</span>",
  ];

  constructor() {}

  ngOnInit() {}

  initOptions(): void {
    if (this.gaugeData.value >= 0 && this.gaugeData.value < 2)
      this.riskLabel = this.riskLabels[0];
    else if (this.gaugeData.value >= 2 && this.gaugeData.value < 4)
      this.riskLabel = this.riskLabels[1];
    else if (this.gaugeData.value >= 4 && this.gaugeData.value < 6)
      this.riskLabel = this.riskLabels[2];
    else if (this.gaugeData.value >= 6 && this.gaugeData.value < 7)
      this.riskLabel = this.riskLabels[3];
    let opt = this.getDefaultOption();
    /**
     * Gauge options & series
     */
    if (this.options) {
      opt = _.merge(opt, this.options);
    }

    /**
     * profile risk data = { value: number, volatility: percent}
     */
    if (this.gaugeData && typeof this.gaugeData === 'object') {
      let risk = this.gaugeData.value;
      if (isNaN(risk) || risk < 0) {
        risk = 0;
      }

      if (risk > 6) {
        risk = 7;
      }

      opt.series = [
        {
          name: 'Niveau de risque du portefeuille',
          data: [risk],
        },
      ];
      this.gaugeOptions = opt;
    }
  }

  getDefaultOption(): any {
    let options = {
      chart: {
        type: 'gauge',
        spacingBottom: 0,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        height: this.height !== 'auto' ? parseInt(this.height, 10) || null : null,
      },
      title: {
        text: '',
      },
      pane: {
        center: ['50%', '55%'],
        size: '100%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: '#fff',
          innerRadius: '100%',
          outerRadius: '100%',
          shape: 'arc',
        },
      },
      tooltip: {
        enabled: false,
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 7,
        lineWidth: 0,
        minorTickInterval: 0,
        tickInterval: 1,
        tickLength: 0,
        title: {
          y: -70,
        },
        labels: {
          y: -5,
          x: 5,
          style: {
            color: '#fff',
            'text-shadow':
              '1px 0 0 #00000070, -1px 0 0 #00000070, 0 1px 0 #00000070, 0 -1px 0 #00000070, 1px 1px #00000070, -1px -1px 0 #00000070, 1px -1px 0 #00000070, -1px 1px 0 #00000070',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 1,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#80a9f9'],
                [1, '#81b2e9'],
              ],
            },
          },
          {
            from: 1,
            to: 2,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#81b2e9'],
                [1, '#83c3c8'],
              ],
            },
          },
          {
            from: 2,
            to: 3,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#83c3c8'],
                [1, '#93cd9c'],
              ],
            },
          },
          {
            from: 3,
            to: 4,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#93cd9c'],
                [1, '#abc680'],
              ],
            },
          },
          {
            from: 4,
            to: 5,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#abc680'],
                [1, '#f0b431'],
              ],
            },
          },
          {
            from: 5,
            to: 6,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#f0b431'],
                [1, '#ee8d48'],
              ],
            },
          },
          {
            from: 6,
            to: 7,
            borderColor: '#fff',
            borderWidth: 1,
            thickness: 50,
            color: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#ee8d48'],
                [1, '#ec6262'],
              ],
            },
          },
        ],
      },
      credits: {
        enabled: false,
      },

      plotOptions: {
        gauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
            padding: 10,
            /* format : this.riskLabel, */
            format: ' ',
            /* formatter: function() {
              let y = this.y ? this.y.toFixed(1) : 0;
              return y;
            }, */
            style: {
              color: '#009dcc',
              fontSize: '1.2rem',
              fontWeight: 'bold',
            },
          },
        },
      },
      series: [{ name: 'risk', data: [4] }],
    };

    return options;
  }
}
